import loadable from "@loadable/component";


loadable.lib(
  () => import(/* webpackChunkName: "client-only-ui" */ "@use-cookie-consent/react"),
  { ssr: false });

loadable.lib(
  () => import(/* webpackChunkName: "client-only-ui" */ "react-gtm-module"),
  { ssr: false });

export const ProtectedRoute = loadable(
  () => import(/* webpackChunkName: "client-only-ui" */ "./protected-route"),
  { ssr: false });

export const RGPDConsentProvider = loadable(
  () => import(/* webpackChunkName: "client-only-ui" */ "@use-cookie-consent/react"),
  { ssr: false, resolveComponent: module => module.CookieConsentProvider });

export const RGPDConsentProcessor = loadable(
  () => import(/* webpackChunkName: "client-only-ui" */ "./rgpd/cookie-consent-provider"),
  { ssr: false });

export const RGPDBanner = loadable(
  () => import(/* webpackChunkName: "client-only-ui" */ "./rgpd/cookie-banner"),
  { ssr: false });

export const SearchBar = loadable(
  () => import(/* webpackChunkName: "client-only-ui" */ "./search-bar/search-bar"),
  { ssr: false });

export const GuestsSelector = loadable(
  () => import(/* webpackChunkName: "client-only-ui" */ "./search-bar/item-selectors/guests"),
  { ssr: false });
